import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Absensi from "@/pages/Absensi";
import Karyawan from "@/pages/Karyawan";
import Sites from "@/pages/Sites";
import Assets from "@/pages/Assets";
import BBM from "@/pages/BBM";
import Maintenance from "@/pages/Maintenance";
import Sparepart from "@/pages/Sparepart";
import Produksi from "@/pages/Produksi";
import Payroll from "@/pages/Payroll";
import Kasbon from "@/pages/Kasbon";
import KasBank from "@/pages/KasBank";
import Purchasing from "@/pages/Purchasing";
import Inventory from "@/pages/Inventory";
import Approval from "@/pages/Approval";
import Budget from "@/pages/Budget";
import Laporan from "@/pages/Laporan";
import QuickInput from "@/pages/QuickInput";
import Settings from "@/pages/Settings";
import Holidays from "@/pages/Holidays";
import Shifts from "@/pages/Shifts";
import RekapAbsensi from "@/pages/RekapAbsensi";
import InventoryMovements from "@/pages/InventoryMovements";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-white">
      <div className="font-mono text-sm text-neutral-400">Memuat sistem...</div>
    </div>
  );
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/quick" element={<Protected><QuickInput /></Protected>} />
            <Route path="/" element={<Protected><Layout /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="absensi" element={<Absensi />} />
              <Route path="karyawan" element={<Karyawan />} />
              <Route path="sites" element={<Sites />} />
              <Route path="assets" element={<Assets />} />
              <Route path="bbm" element={<BBM />} />
              <Route path="maintenance" element={<Maintenance />} />
              <Route path="sparepart" element={<Sparepart />} />
              <Route path="produksi" element={<Produksi />} />
              <Route path="payroll" element={<Payroll />} />
              <Route path="kasbon" element={<Kasbon />} />
              <Route path="kas-bank" element={<KasBank />} />
              <Route path="purchasing" element={<Purchasing />} />
              <Route path="inventory" element={<Inventory />} />
              <Route path="approval" element={<Approval />} />
              <Route path="budget" element={<Budget />} />
              <Route path="laporan" element={<Laporan />} />
              <Route path="rekap-absensi" element={<RekapAbsensi />} />
              <Route path="holidays" element={<Holidays />} />
              <Route path="shifts" element={<Shifts />} />
              <Route path="movements" element={<InventoryMovements />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
